<template>
  <div>
    <div
      v-if="itemData && itemData.id"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <b-button
        v-if="false"
        variant="outline-secondary"
        size="sm"
        @click="selectGuideModalVisible = true"
      >
        <feather-icon icon="BookOpenIcon" />
        {{ $t('tasks.edit.loadFromGuide') }}
      </b-button>
    </div>
    <b-alert
      :show="denied"
      variant="warning"
    >
      <div class="alert-body">
        {{ $t('tasks.edit.denied') }}
      </div>
    </b-alert>
    <validation-observer
      v-if="!denied"
      ref="simpleRules"
    >
      <tasks-item-form />
      <save-button
        :save-action="submitForm"
        :is-disabled="submitStatus"
      />
    </validation-observer>
    <select-guide-modal
      v-model="selectGuideModalVisible"
      @selected="onGuideSelected"
    />
    <hr
      v-if="!denied && itemData && itemData.id"
      class="my-2"
    >
    <subtasks-list
      v-if="!denied && itemData && itemData.id"
      :id-tasks="Number(itemData.id)"
    />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { BAlert, BButton } from 'bootstrap-vue'
import { canManageTask } from '@/auth/taskPermissions'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import TasksItemForm from '@/views/Tasks/ItemForm.vue'
import SelectGuideModal from '@/views/Tasks/Components/SelectGuideModal.vue'
import SubtasksList from '@/views/Tasks/Components/SubtasksList.vue'

export default {
  name: 'Edit',
  components: {
    TasksItemForm,
    ValidationObserver,
    SaveButton,
    BAlert,
    BButton,
    SelectGuideModal,
    SubtasksList,
  },
  data: () => ({
    submitStatus: false,
    selectGuideModalVisible: false,
    loaded: false,
  }),
  computed: {
    denied() {
      if (!this.loaded || this.$store.getters['tasks/loading']) return false
      return !this.itemData?.id || !canManageTask(this.itemData)
    },
    itemData() {
      return this.$store.getters['tasks/dataItem']
    },
    saveData() {
      return this.$store.getters['tasks/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val?.watcherError) {
        this.showToast({
          variant: 'warning', title: this.$t('common.toast.warning'), icon: 'AlertTriangleIcon', text: this.$t('tasks.form.watcherError'),
        })
      }
      if (val?.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val?.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('tasks/getDataItem', this.$route.params.id)
        .then(res => {
          this.loaded = true
          if (res) {
            if (res.id_departments) {
              this.$store.dispatch('teams/getDataList', {
                select: ['teams.id AS id', 'teams.title AS title'],
                where: { 'teams.status': 1, 'teams.id_departments': res.id_departments },
                limit: 500,
                start: 0,
              })
            }
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('tasks/saveData', this.itemData)
            .then(response => {
              if (response.status === true) {
                this.submitStatus = false
              }
            })
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'), icon: 'XIcon', text: this.$t('common.requiredFields'), variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({ component: ToastificationContent, props: params }, { position: 'bottom-center' })
    },
    async onGuideSelected(guide) {
      try {
        await this.$store.dispatch('guides/createSubtasksFromGuide', {
          id_guides: guide.id,
          id_tasks: this.itemData.id,
        })
        this.showToast({
          variant: 'success',
          title: this.$t('common.toast.successShort'),
          icon: 'CheckIcon',
          text: this.$t('tasks.edit.guideStepsAdded'),
        })
        this.selectGuideModalVisible = false
        this.$store.dispatch('subtasks/getDataList', {
          where: { 'subtasks.id_tasks': this.itemData.id },
        })
      } catch (e) {
        this.showToast({
          variant: 'danger',
          title: this.$t('common.toast.errorShort'),
          icon: 'XIcon',
          text: e?.message || this.$t('tasks.edit.guideStepsFailed'),
        })
      }
    },
  },
}
</script>
